import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import useStyles from "./style";
const SnackBar = ({ text, severity, show, HandleShow, time }) => {
  const classes = useStyles();
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={show}
      autoHideDuration={time}
      onClose={() => {
        HandleShow(false);
      }}
      className={classes.alert}
    >
      <Alert severity={severity}>{text}</Alert>
    </Snackbar>
  );
};

export default SnackBar;
